import { useRef, useEffect } from 'react';

/*
 * Component that tries to encapsulate the machinery necessary to take
 * screenshots from a video based on https://developer.mozilla.org/en-US/docs/Web/API/Media_Capture_and_Streams_API/Taking_still_photos
 *
 * Puts a function that should [try to] give screenshots as a result into screenshotFunctionRef.current.
 * It will be set to null if things aren't right for taking screenshots.
 * There may be a better or "more react-y" way to pass the functionality 'upwards' but idk what it is
 * 
 * shotWidth = width (in pixels) of the shot; height will be based on aspect ratio of the input video.
 * If typeof shotWidth !== "number", or it is omitted, the video's own width and height will be used instead.
 * shotType = mime type passed to canvas.toDataUrl.
 */

function VideoScreenshotCapture({ videoRef, screenshotFunctionRef, shotWidth=null, shotType="image/png" }) {
  const theCanvas = useRef(null);

  useEffect(() => {
    if (typeof videoRef === "object" && videoRef.current instanceof HTMLVideoElement) {
      screenshotFunctionRef.current = () => {
        // The basic idea here is that we draw the video in the canvas and then use canvas.toDataURL to return a
        // base64 / blob of the image on the canvas.
        // If the video isn't around you get weird results though.

        // shadow the height so we can manipulate it.
        let height = undefined;
        let width = shotWidth;
        const {videoWidth, videoHeight} = videoRef.current;

        if (typeof width === "number") {
          height = (videoHeight / videoWidth) * width;
        } else {
          [width, height] = [videoWidth, videoHeight];
        }

        console.log("Screenshot dimensions: ", [width, height]);
      
        const canvas = theCanvas.current;
        canvas.setAttribute("width", width);
        canvas.setAttribute("height", height);
        const context = canvas.getContext("2d");
        context.drawImage(videoRef.current, 0, 0, width, height);
        return canvas.toDataURL("image/png");
      }
    } else {
      screenshotFunctionRef.current = null;
    }
  }, [videoRef, shotWidth]);

  return (<>
    <canvas ref={theCanvas} style={{display: "none"}}/>
  </>);
}

export default VideoScreenshotCapture;